import { NodePreviewHtml } from "./NodePreviewHtml";
import { NodePreviewStock } from "./NodePreviewStock";

// TODO: 这里的 any 应该需要补充成其他 contentType 明确的类型
export type NodePreviewContentType = NodePreviewStock | NodePreviewHtml | any;

export class NodePreviewContentResult {
  constructor(public content: NodePreviewContentType, public contentType: PreviewApp.PreviewContentType) {}
}
